<div class="resource-attributes-section">
  <!-- Header row: title + count. Tags are edited inline per row (ADO-style),
       so there is no edit pencil. -->
  <div class="attributes-header-row">
    <span class="attributes-title">Attributes</span>
    <span class="attributes-count">({{ totalCount }})</span>
  </div>

  @if (isLoading) {
    <div class="loading-row">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
  } @else {
    <div class="attribute-rows">
      @for (category of categories; track category.key) {
        <div class="attribute-row">
          <span class="attribute-label">{{ category.label }}</span>
          <div class="attribute-values">
            @for (value of getValues(category); track value.code) {
              <span class="attribute-value-label">
                <span class="attribute-value-name">{{ value.name }}</span>
                @if (!isReadOnly()) {
                  <!-- A real button, not a clickable mat-icon: focus, Enter/Space
                       and the button role come for free, so removing a tag is
                       reachable without a mouse. The aria-label names the tag and
                       its category, since "Remove" alone is ambiguous when a row
                       holds several tags. -->
                  <button
                    type="button"
                    class="attribute-value-remove"
                    [attr.aria-label]="
                      'Remove ' + value.name + ' from ' + category.label
                    "
                    [disabled]="isSavingTag"
                    (click)="removeTag(category, value)"
                    matTooltip="Remove"
                    matTooltipPosition="below"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </span>
            }

            @if (!isReadOnly()) {
              @if (addingCategoryKey === category.key) {
                <!-- Inline add input with typeahead suggestions (ADO-style) -->
                <div class="tag-input-wrapper">
                  <input
                    #tagInputEl
                    class="tag-input"
                    type="text"
                    placeholder="Type to add..."
                    [(ngModel)]="tagInputText"
                    [disabled]="isSavingTag"
                    (keydown.enter)="onInputEnter(category)"
                    (keydown.escape)="closeAdd()"
                    (blur)="onInputBlur()"
                    autocomplete="off"
                  />
                  @if (isSavingTag) {
                    <mat-spinner class="tag-input-spinner" diameter="16"></mat-spinner>
                  }
                  @if (!isSavingTag && (getSuggestions(category).length > 0 || isNewTagText(category))) {
                    <div
                      class="tag-suggestions"
                      role="listbox"
                      [attr.aria-label]="category.label + ' suggestions'"
                    >
                      @if (isNewTagText(category)) {
                        <div
                          role="option"
                          class="tag-suggestion tag-suggestion--create"
                          (mousedown)="$event.preventDefault(); onInputEnter(category)"
                        >
                          <mat-icon>add</mat-icon>
                          <span>Create "{{ tagInputText.trim() }}"</span>
                        </div>
                      }
                      @for (option of getSuggestions(category); track option.value) {
                        <div
                          role="option"
                          class="tag-suggestion"
                          (mousedown)="$event.preventDefault(); addExisting(category, option)"
                        >
                          {{ option.label }}
                        </div>
                      }
                    </div>
                  }
                </div>
              } @else {
                @if (getValues(category).length > 0) {
                  <button
                    type="button"
                    class="add-tag-plus"
                    (click)="startAdd(category)"
                    matTooltip="Add {{ category.label }}"
                    matTooltipPosition="below"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                } @else {
                  <button
                    type="button"
                    class="add-tag-empty"
                    (click)="startAdd(category)"
                  >
                    <mat-icon>add</mat-icon>
                    <span>Add {{ category.label }}</span>
                  </button>
                }
              }
            } @else if (getValues(category).length === 0) {
              <span class="empty-value">None</span>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
